import React from 'react';
import { FadeIn } from './FadeIn';
import { Zap } from 'lucide-react';
export function MicroInertia() {
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-114">
      <FadeIn data-id="element-115">
        <div className="relative rounded-3xl overflow-hidden" data-id="element-116">
          {/* Background gradient effect */}
          <div className="absolute inset-0 bg-gradient-to-br from-amber-500/20 to-slate-900/80 z-0" data-id="element-117"></div>
          <div className="absolute inset-0 border-2 border-amber-500/30 rounded-3xl z-0" data-id="element-118"></div>

          <div className="relative z-10 p-8 md:p-12 lg:p-16" data-id="element-119">
            <div className="flex items-center gap-4 mb-8" data-id="element-120">
              <div className="bg-amber-500 p-3 rounded-full shadow-[0_0_15px_rgba(245,158,11,0.5)]" data-id="element-121">
                <Zap className="w-8 h-8 text-slate-900" data-id="element-122" />
              </div>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-123">
                El Mecanismo Único
              </h2>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-slate-200 leading-relaxed" data-id="element-124">
              <p data-id="element-125">
                La clave no es la disciplina, es la{' '}
                <strong className="text-amber-400 text-2xl" data-id="element-126">
                  Micro-Inercia.
                </strong>
              </p>
              <p data-id="element-127">
                Este método hackea la física de tu cerebro reduciendo la
                fricción inicial a niveles tan ridículos que el "sistema de
                seguridad" de tu TDAH no se activa.
              </p>
              <blockquote className="border-l-4 border-amber-500 pl-6 py-2 my-8 text-2xl md:text-3xl font-heading font-medium text-white italic" data-id="element-128">
                "No intentamos saltar el muro; le quitamos los ladrillos uno a
                uno hasta que el primer paso sea inevitable."
              </blockquote>
              <p data-id="element-129">
                En lugar de luchar contra tu biología, usamos la inercia física
                para generar el flujo químico que necesitas para seguir
                adelante.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}